import API_BASE_URL from "../config";
import { clearAuthSession, getStoredToken } from "./authStorage";
import { getSubscriberSubdomainHeader } from "./reportRequestHeaders";

function redirectToLogin() {
  const currentPath = `${window.location.pathname}${window.location.search || ""}`;
  sessionStorage.setItem("redirect_after_login", currentPath);
  clearAuthSession();
  window.location.replace("/login");
}

export async function authFetch(path, options = {}) {
  const token = getStoredToken();

  const headers = {
    ...(options.headers || {}),
    ...getSubscriberSubdomainHeader()
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(
    path.startsWith("http") ? path : `${API_BASE_URL}${path}`,
    {
      ...options,
      headers
    }
  );

  if (response.status === 401) {
    redirectToLogin();
    throw new Error("Your session has expired. Please log in again.");
  }

  return response;
}

export async function authJsonFetch(path, options = {}) {
  const response = await authFetch(path, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {})
    }
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || data.error || "Request failed");
  }

  return data;
}